"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Union = exports.Optional = void 0;
const Optional = (typeCheckerFunction) => {
    return (value) => {
        if (value === undefined)
            return true;
        return typeCheckerFunction(value);
    };
};
exports.Optional = Optional;
const Union = (...typeCheckerFunctions) => {
    return (value) => {
        return typeCheckerFunctions.some((typeCheckerFunction) => typeCheckerFunction(value));
    };
};
exports.Union = Union;
